// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */
import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import {closeLockEBadgeModalAction, eBadgeLockAction} from "../../actions/ebadge/creators/eBadgeLockActionCreator";
import {extractCaller} from "../QueryPage";
import type {GenericModalDispatchProps, GenericModalStateProps} from "../../components/GenericModal";
import GenericModal from "../../components/GenericModal";
import type {Caller} from "../../components/QueryPage";
import EBadge from "../../model/ebadge/EBadge";

function getIsLoadingStatus(state, registrationCode) {
    let eBadgeLockStatus = state.eBadgeAction.lock[registrationCode];
    if (eBadgeLockStatus) {
        return eBadgeLockStatus.isLoading;
    } else {
        return false;
    }
}

type Args = {
    registrationCode: string,
    caller: Caller
}

const mapStateToProps = (state: StoreState): GenericModalStateProps => {

    const registrationCode = state.eBadgeAction.lock.modal.registrationCode;
    const isLoading = registrationCode ? getIsLoadingStatus(state, registrationCode)
                                                                : false;

    const args: Args = {
        registrationCode: registrationCode || '',
        caller: extractCaller(state)
    };
    return {
        open: state.eBadgeAction.lock.modal.open,
        promptMsg: `Are you sure to link ${registrationCode || 'EBadge'}? No users will be able to redeem this e-Badge once linked.`,
        loadingMsg: `OK. We are linking ${registrationCode || 'EBadge'}`,
        isLoading,
        error: state.eBadgeAction.lock.error,
        primaryActionText: 'Link',
        primaryActionColor: "success",
        args: args
    }
};

const mapDispatchToProps = (dispatch): GenericModalDispatchProps => {
    return {
        primaryAction: (args: Args) => {
            dispatch(eBadgeLockAction(args.registrationCode, args.caller));
        },
        closeModal: () => {
            dispatch(closeLockEBadgeModalAction());
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(GenericModal);



// WEBPACK FOOTER //
// ./src/containers/ebadge/LockEBadgeModal.js